import { useMap } from "react-leaflet";
import { useEffect } from "react";
import L from "leaflet";

const FitBounds = ({ geoJsonData }) => {
    const map = useMap();

    useEffect(() => {
        if (geoJsonData) {
            // Create a temporary GeoJSON layer to compute bounds.
            const layer = L.geoJSON(geoJsonData);
            const bounds = layer.getBounds();
            // Fit the map view to the bounds of the polygon.
            map.fitBounds(bounds);
        }
    }, [map, geoJsonData]);

    return null;
};

export default FitBounds;
